// vim: ft=javascriptreact
import { useContext } from 'react'
import { ImperialBookingContext } from './context/ImperialBookingContext'
import {
  Row,
  Col,
  Alert,
} from 'react-bootstrap'
import { Link } from 'react-router-dom'

const VerifyPhoneNumberBanner = () => {
  const {
    residentLoaded,
    isPhoneVerified,
  } = useContext(ImperialBookingContext)

  if (residentLoaded && !isPhoneVerified) {
    return (
      <Row>
        <Col>
          <Alert variant="warning" className="my-3 lead">
            <strong>Until your phone number is verified, you will not be able to use the lower level of the amenities room. Please <Link to="/account">verify your phone number</Link> to fully-activate your account.</strong>
          </Alert>
        </Col>
      </Row>
    )
  }

  return null;
}

export default VerifyPhoneNumberBanner;
